/* FF — Collection Carousel */
(function(){
  // --- Utilities -------------------------------------------------------------
  function applyActive(root, buttons, activeId){
    buttons.forEach(function(btn){
      const is = btn.dataset.tab === activeId;
      btn.setAttribute('aria-selected', is ? 'true' : 'false');
      btn.classList.toggle('is-active', !!is);

      // Keep this: active tab should not have .fx
      // Drop re-adding .fx to inactive tabs (that caused flashing before).
      if (is) {
        btn.classList.remove('fx');
      }
    });
  }

  function pickSize(btn){
    const m = window.matchMedia('(max-width: 749px)').matches;
    const sz = parseFloat(m ? (btn.getAttribute('data-sub-size-m') || '') : (btn.getAttribute('data-sub-size') || ''));
    return isNaN(sz) ? null : sz;
  }

  function applySubtitleDefaults(root, el){
    if(!el) return;
    // Reset to section-level CSS variable (declared in scoped <style>)
    el.style.removeProperty('--ffcc-sub-font');
    el.style.fontWeight = root.getAttribute('data-sub-default-weight') || '';
    el.style.color = root.getAttribute('data-sub-default-color') || '';
    el.style.letterSpacing = (root.getAttribute('data-sub-default-ls') || '0') + 'em';
    el.style.lineHeight = root.getAttribute('data-sub-default-lh') || '';
    el.style.textTransform = root.getAttribute('data-sub-default-transform') || 'none';
    el.style.fontStyle = (root.getAttribute('data-sub-default-italic') === 'true') ? 'italic' : 'normal';
    var defSz = root.getAttribute('data-sub-default-size');
    var defSzM = root.getAttribute('data-sub-default-size-m');
    el.style.fontSize = (window.matchMedia('(max-width: 749px)').matches ? defSzM : defSz) + 'px';
  }

  function applySubtitleFrom(root, btn){
    const el = root.querySelector('[data-role="subtitle"]');
    if(!el) return;
    el.textContent = (btn && btn.getAttribute('data-subheading')) || '';

    if(!btn) { applySubtitleDefaults(root, el); return; }

    const override = btn.getAttribute('data-sub-override') === 'true';
    if(!override){ applySubtitleDefaults(root, el); return; }

    // Per-tab override
    const fam  = btn.getAttribute('data-sub-font-family') || '';
    const fall = btn.getAttribute('data-sub-font-fallbacks') || '';
    if(fam){ el.style.setProperty('--ffcc-sub-font', fam + (fall ? ', ' + fall : '') + ', var(--font-heading-family)'); }
    el.style.fontWeight    = btn.getAttribute('data-sub-weight') || '';
    el.style.color         = btn.getAttribute('data-sub-color') || '';
    el.style.letterSpacing = (btn.getAttribute('data-sub-ls') || '0') + 'em';
    el.style.lineHeight    = btn.getAttribute('data-sub-lh') || '';
    el.style.textTransform = btn.getAttribute('data-sub-transform') || 'none';
    el.style.fontStyle     = (btn.getAttribute('data-sub-italic') === 'true') ? 'italic' : 'normal';
    const size = pickSize(btn);
    if(size){ el.style.fontSize = size + 'px'; }
  }

  // --- Helpers: throttling & measuring --------------------------------------
  function throttleRaf(fn){
    let raf = null;
    return function(){
      if(raf) return;
      const ctx = this, args = arguments;
      raf = requestAnimationFrame(function(){ raf = null; fn.apply(ctx,args); });
    };
  }

  // Keep page scroll position stable while we temporarily unhide/measure/toggle
  function preservePageScroll(run){
    const docEl = document.documentElement;
    const prevBehavior = docEl.style.scrollBehavior || '';
    docEl.style.scrollBehavior = 'auto';
    const x = window.scrollX, y = window.scrollY;
    try { run(); } finally {
      window.scrollTo(x, y);
      docEl.style.scrollBehavior = prevBehavior;
    }
  }

  // Reserve space equal to tallest visible track across all tabs (prevents "View all" jump)
  // Measure *natural* height by temporarily forcing min-height:0. Hidden panels are
  // measured off-canvas via transform so they never widen the page.
  function computeCardsMinHeight(root){
    preservePageScroll(function(){
      const panels = root.querySelectorAll('.ff-cc__panel');
      let maxH = 0;

      panels.forEach(function(panel){
        const track = panel.querySelector('.ff-cc__track');
        if(!track) return;

        const wasHidden = panel.hasAttribute('hidden');

        // snapshot styles we touch
        let prevPos, prevVis, prevPE, prevTransform, prevTop, prevLeft, prevMinH;
        if (wasHidden) {
          prevPos       = panel.style.position;
          prevVis       = panel.style.visibility;
          prevPE        = panel.style.pointerEvents;
          prevTransform = panel.style.transform;
          prevTop       = panel.style.top;
          prevLeft      = panel.style.left;

          panel.removeAttribute('hidden');
          panel.style.position      = 'absolute';
          panel.style.visibility    = 'hidden';
          panel.style.pointerEvents = 'none';
          panel.style.top           = '0';
          panel.style.left          = '0';
          // off-canvas without affecting layout width
          panel.style.transform     = 'translate3d(-200vw,0,0)';
        }

        prevMinH = track.style.minHeight;
        track.style.minHeight = '0px';

        const rectH = track.getBoundingClientRect().height || 0;
        const natH  = Math.max(track.scrollHeight || 0, rectH);
        if(natH > maxH) maxH = natH;

        track.style.minHeight = prevMinH || '';

        if (wasHidden) {
          panel.style.position      = prevPos || '';
          panel.style.visibility    = prevVis || '';
          panel.style.pointerEvents = prevPE || '';
          panel.style.top           = prevTop || '';
          panel.style.left          = prevLeft || '';
          panel.style.transform     = prevTransform || '';
          panel.setAttribute('hidden','hidden');
        }
      });

      root.style.setProperty('--ffcc-item-h', (Math.ceil(maxH) + 1) + 'px');
    });
  }

  // Subtitle box reserve (prevents header jump when per-tab typography differs)
  function computeSubtitleBoxHeights(root){
    const header = root.querySelector('.ff-cc__header');
    if(!header) return;

    const tabs = root.querySelectorAll('.ff-cc__tab');
    const meas = document.createElement('p');
    meas.className = 'ff-cc__subtitle';
    // Absolute + off-canvas transform (no layout width impact)
    meas.style.position   = 'absolute';
    meas.style.left       = '0';
    meas.style.top        = '0';
    meas.style.transform  = 'translate3d(-200vw,0,0)';
    meas.style.visibility = 'hidden';
    meas.style.margin     = '0';
    header.appendChild(meas);

    var headingFont = getComputedStyle(root).getPropertyValue('--font-heading-family').trim() || 'sans-serif';
    function applyDefaults(){
      var fam = (root.getAttribute('data-sub-default-font-family') || '');
      var fall = (root.getAttribute('data-sub-default-fallbacks') || root.getAttribute('data-sub-default-font-fallbacks') || '');
      meas.style.fontFamily    = (fam ? fam + ', ' : '') + (fall ? fall + ', ' : '') + headingFont;
      meas.style.fontWeight    = root.getAttribute('data-sub-default-weight') || '';
      meas.style.letterSpacing = (root.getAttribute('data-sub-default-ls') || '0') + 'em';
      meas.style.lineHeight    = root.getAttribute('data-sub-default-lh') || '';
      meas.style.textTransform = root.getAttribute('data-sub-default-transform') || 'none';
      meas.style.fontStyle     = (root.getAttribute('data-sub-default-italic') === 'true') ? 'italic' : 'normal';
      meas.style.color         = 'transparent';
    }
    function applyFromBtn(btn, mobile){
      const override = btn.getAttribute('data-sub-override') === 'true';
      if(override){
        const fam  = btn.getAttribute('data-sub-font-family') || '';
        const fall = btn.getAttribute('data-sub-font-fallbacks') || '';
        meas.style.fontFamily    = (fam ? fam + ', ' : '') + (fall ? fall + ', ' : '') + headingFont;
        meas.style.fontWeight    = btn.getAttribute('data-sub-weight') || '';
        meas.style.letterSpacing = (btn.getAttribute('data-sub-ls') || '0') + 'em';
        meas.style.lineHeight    = btn.getAttribute('data-sub-lh') || '';
        meas.style.textTransform = btn.getAttribute('data-sub-transform') || 'none';
        meas.style.fontStyle     = (btn.getAttribute('data-sub-italic') === 'true') ? 'italic' : 'normal';
        const sz = parseFloat(mobile ? (btn.getAttribute('data-sub-size-m') || '') : (btn.getAttribute('data-sub-size') || ''));
        meas.style.fontSize = isNaN(sz) ? '' : (sz + 'px');
      } else {
        applyDefaults();
        const fallback = (mobile ? root.getAttribute('data-sub-default-size-m') : root.getAttribute('data-sub-default-size')) || '16';
        meas.style.fontSize = fallback + 'px';
      }
      meas.textContent = btn.getAttribute('data-subheading') || 'Hg';
    }

    let maxD = 0, maxM = 0;
    applyDefaults();
    meas.style.fontSize = (root.getAttribute('data-sub-default-size') || '16') + 'px';
    meas.textContent = 'Hg';
    maxD = Math.max(maxD, meas.offsetHeight);
    meas.style.fontSize = (root.getAttribute('data-sub-default-size-m') || '14') + 'px';
    maxM = Math.max(maxM, meas.offsetHeight);

    tabs.forEach(function(btn){
      applyFromBtn(btn,false); maxD = Math.max(maxD, meas.offsetHeight);
      applyFromBtn(btn,true);  maxM = Math.max(maxM, meas.offsetHeight);
    });

    header.removeChild(meas);
    root.style.setProperty('--ffcc-subbox-h',  Math.ceil(maxD) + 'px');
    root.style.setProperty('--ffcc-subbox-h-m', Math.ceil(maxM) + 'px');
  }

  const recomputeAllThrottled = throttleRaf(function(root){
    computeSubtitleBoxHeights(root);
    computeCardsMinHeight(root);
  });

  // --- Tabs horizontal scroll with interactive fades + optional centering ----
  function initTabsTrack(root){
    const wrap = root.querySelector('.ff-cc__tabswrap');
    const track = root.querySelector('.ff-cc__tabs');
    if(!wrap || !track) return;

    const centerIfTitle = (root.getAttribute('data-center-tabs-if-title-centered') === 'true');

    function getTitleAlign(){
      const mqMobile = window.matchMedia('(max-width: 749px)').matches;
      return (mqMobile ? (root.getAttribute('data-title-align-mobile') || 'left')
                       : (root.getAttribute('data-title-align') || 'left'));
    }

    function cssNum(el, prop){
      const v = getComputedStyle(el).getPropertyValue(prop);
      if(!v) return 0;
      const n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    }

    function easeOutQuad(t){ return 1 - (1 - t) * (1 - t); }

    let raf = null;
    function updateInteractiveMask(){
      const overflow = track.scrollWidth > Math.ceil(track.clientWidth) + 1;
      const atStart = track.scrollLeft <= 1;
      const atEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 1);

      wrap.classList.toggle('is-overflow', overflow);
      wrap.classList.toggle('is-start',  atStart || !overflow);
      wrap.classList.toggle('is-end',    atEnd   || !overflow);

      const shouldCenter = centerIfTitle && !overflow && getTitleAlign() === 'center';
      wrap.classList.toggle('is-centered', !!shouldCenter);

      const fadeW   = cssNum(track, '--tabs-fade-w');
      const fadeOp  = parseFloat(getComputedStyle(track).getPropertyValue('--tabs-fade-op')) || 0.0;
      const maxX    = Math.max(0, track.scrollWidth - track.clientWidth);
      const x       = Math.max(0, Math.min(track.scrollLeft, maxX));

      if(!overflow || fadeW <= 0 || fadeOp <= 0){
        track.style.setProperty('--fadeL', '0px');
        track.style.setProperty('--fadeR', '0px');
        track.style.setProperty('--fadeLalpha', '0');
        track.style.setProperty('--fadeRalpha', '0');
        return;
      }

      const ramp = Math.max(1, fadeW * 1.25);
      const leftProg  = easeOutQuad(Math.min(1, x / ramp));
      const rightProg = easeOutQuad(Math.min(1, (maxX - x) / ramp));

      track.style.setProperty('--fadeL',      (fadeW * leftProg).toFixed(1)  + 'px');
      track.style.setProperty('--fadeR',      (fadeW * rightProg).toFixed(1) + 'px');
      track.style.setProperty('--fadeLalpha', (leftProg  * fadeOp).toFixed(3));
      track.style.setProperty('--fadeRalpha', (rightProg * fadeOp).toFixed(3));
    }

    function update(){
      if(raf) return;
      raf = requestAnimationFrame(function(){ raf = null; updateInteractiveMask(); });
    }

    track.addEventListener('scroll', update, { passive: true });
    if('ResizeObserver' in window){
      const ro = new ResizeObserver(update);
      ro.observe(track);
    } else {
      window.addEventListener('resize', update);
    }
    const mq = window.matchMedia('(max-width: 749px)');
    if(mq.addEventListener){ mq.addEventListener('change', update); }
    else if(mq.addListener){ mq.addListener(update); }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(update).catch(function(){}); }

    update();
    requestAnimationFrame(update);
    setTimeout(update, 120);
  }

  // --- Product panels (arrows with easing, no wheel hijack) ------------------
  function initPanel(panel, hideRedundant, fadeEnabled, fadeWidth, fadeOpacity){
    if(!panel) return;

    const track = panel.querySelector('.ff-cc__track');
    const prev = panel.querySelector('.ff-cc__arrow--prev');
    const next = panel.querySelector('.ff-cc__arrow--next');
    if(!track) return;

    // firstInit = first time we ever wire listeners for this panel
    const firstInit = !panel.dataset._init;
    if(firstInit){
      panel.dataset._init = '1';
      if(fadeEnabled) track.classList.add('has-fade');
    }

    function setOff(el, off){
      if(!el) return;
      el.classList.toggle('is-off', !!off);
      el.setAttribute('aria-hidden', off ? 'true' : 'false');
    }

    function update(){
      const overflow = track.scrollWidth > Math.ceil(track.clientWidth) + 1;
      const atStart = track.scrollLeft <= 1;
      const atEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 1);

      panel.classList.toggle('is-start', atStart || !overflow);
      panel.classList.toggle('is-end',   atEnd   || !overflow);

      if(hideRedundant){
        setOff(prev, !overflow || atStart);
        setOff(next, !overflow || atEnd);
      } else {
        setOff(prev, !overflow);
        setOff(next, !overflow);
      }

      /* Edge fade (mask-image driven by scroll position) */
      if(fadeEnabled){
        if(!overflow){
          track.style.removeProperty('--ffcc-fadeL');
          track.style.removeProperty('--ffcc-fadeR');
          track.style.removeProperty('--ffcc-fadeLa');
          track.style.removeProperty('--ffcc-fadeRa');
          return;
        }
        var maxX = Math.max(0, track.scrollWidth - track.clientWidth);
        var x = Math.max(0, Math.min(track.scrollLeft, maxX));
        var lp = Math.min(x / fadeWidth, 1);
        var rp = Math.min((maxX - x) / fadeWidth, 1);
        var eL = 1 - (1 - lp) * (1 - lp);
        var eR = 1 - (1 - rp) * (1 - rp);
        track.style.setProperty('--ffcc-fadeL', (eL * fadeWidth) + 'px');
        track.style.setProperty('--ffcc-fadeR', (eR * fadeWidth) + 'px');
        track.style.setProperty('--ffcc-fadeLa', atStart ? '1' : String(fadeOpacity));
        track.style.setProperty('--ffcc-fadeRa', atEnd ? '1' : String(fadeOpacity));
      }
    }

    function pageScroll(dir){
      const page = Math.max(1, Math.floor(track.clientWidth * 0.9));
      track.scrollBy({ left: dir === 'next' ? page : -page, behavior: 'smooth' });
    }

    if(firstInit){
      // attach once
      prev && prev.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        pageScroll('prev');
      });
      next && next.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        pageScroll('next');
      });

      // NOTE: No custom wheel handler. We allow normal vertical scrolling of the page on desktop.

      track.addEventListener('scroll', throttleRaf(update), { passive: true });

      if('ResizeObserver' in window){
        const ro = new ResizeObserver(throttleRaf(update));
        ro.observe(track);
      } else {
        window.addEventListener('resize', throttleRaf(update));
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(update).catch(function(){});
      }
    }

    // always sync arrow state
    update();
  }

  function ensureTabHorizVisible(root, btn){
    if(!btn) return;
    const track = root.querySelector('.ff-cc__tabs');
    if(!track) return;

    // Only change the tabs track's horizontal scroll; never the page scroll.
    const btnLeft  = btn.offsetLeft;
    const btnRight = btnLeft + btn.offsetWidth;
    const viewLeft = track.scrollLeft;
    const viewRight = viewLeft + track.clientWidth;

    let target = viewLeft;
    const pad = Math.max(0, (track.clientWidth - btn.offsetWidth) / 2); // soft-center

    if (btnLeft < viewLeft) {
      target = btnLeft - pad;
    } else if (btnRight > viewRight) {
      target = btnRight - track.clientWidth + pad;
    }

    target = Math.max(0, Math.min(target, track.scrollWidth - track.clientWidth));
    track.scrollTo({ left: target, behavior: 'smooth' });
  }

  // --- Tab selection + subtitle + recompute ---------------------------------
  function selectTab(root, id){
    const tabs   = root.querySelectorAll('.ff-cc__tab');
    const panels = root.querySelectorAll('.ff-cc__panel');
    let activeBtn = null;

    // 1. BEFORE we flip states, freeze tab transitions so they don't "flash"
    tabs.forEach(function(btn){
      if(btn.dataset.tab === id){
        activeBtn = btn;
      }
      btn.classList.add('no-trans-temp');
    });

    // 2. Apply active/inactive classes (no animated fade because .no-trans-temp is on)
    applyActive(root, tabs, id);

    // 3. Keep the clicked tab in view without touching page scroll
    ensureTabHorizVisible(root, activeBtn);

    // 4. Figure out which panel we're showing
    let targetPanel = null;
    panels.forEach(function(p){
      if(p.id.endsWith(id)){
        targetPanel = p;
      }
    });

    // 5. Grab that panel's arrows so we can suppress THEIR transition during swap
    const tPrev = targetPanel ? targetPanel.querySelector('.ff-cc__arrow--prev') : null;
    const tNext = targetPanel ? targetPanel.querySelector('.ff-cc__arrow--next') : null;
    if(tPrev) tPrev.classList.add('no-anim-temp');
    if(tNext) tNext.classList.add('no-anim-temp');

    // 6. Toggle panels + subtitle and keep scroll position locked
    preservePageScroll(function(){
      panels.forEach(function(p){
        const trackEl = p.querySelector('.ff-cc__track');
        if(!trackEl) return;

        if(p === targetPanel){
          // showing this panel
          p.removeAttribute('hidden');

          // restore saved horizontal scroll position if we have one
          if(trackEl.dataset.savedLeft){
            const saved = parseFloat(trackEl.dataset.savedLeft);
            if(!isNaN(saved)){
              trackEl.scrollLeft = saved;
            }
          }
        } else {
          // hiding this panel if it was visible
          if(!p.hasAttribute('hidden')){
            trackEl.dataset.savedLeft = trackEl.scrollLeft;
            p.setAttribute('hidden','hidden');
          }
        }
      });

      applySubtitleFrom(root, activeBtn);
    });

    // 7. Init arrows / overflow logic for the now-active panel
    const hideRedundant = (root.getAttribute('data-arrows-hide-redundant') || 'true') === 'true';
    const fadeEnabled = root.getAttribute('data-fade-enabled') !== 'false';
    const fadeWidth = parseFloat(root.getAttribute('data-fade-width')) || 36;
    var fadeOpacity = parseFloat(root.getAttribute('data-fade-opacity'));
    if (isNaN(fadeOpacity)) fadeOpacity = 0;
    initPanel(targetPanel, hideRedundant, fadeEnabled, fadeWidth, fadeOpacity);

    // 8. Next frame: unfreeze transitions for tabs AND restore arrow transitions.
    //    This prevents a "violent flash" frame.
    requestAnimationFrame(function(){
      if(tPrev) tPrev.classList.remove('no-anim-temp');
      if(tNext) tNext.classList.remove('no-anim-temp');

      tabs.forEach(function(btn){
        btn.classList.remove('no-trans-temp');
      });
    });

    // 9. Recompute reserved heights (subtitle box + tallest track)
    recomputeAllThrottled(root);
    setTimeout(function(){ recomputeAllThrottled(root); }, 120);
  }

  // --- Section bootstrap -----------------------------------------------------
  function initSection(root){
    if(!root) return;
    root.dataset.sectionId = root.getAttribute('data-section-id');

    initTabsTrack(root);

    const tabs = root.querySelectorAll('.ff-cc__tab');
    tabs.forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        selectTab(root, btn.dataset.tab);
      });
      btn.addEventListener('keydown', function(e){
        if(e.key === 'ArrowRight' || e.key === 'ArrowLeft'){
          e.preventDefault();
          const list = Array.from(tabs);
          const i = list.indexOf(btn);
          const nextI = e.key === 'ArrowRight' ? (i+1) % list.length : (i-1+list.length) % list.length;
          list[nextI].focus();
          list[nextI].click();
        }
      });
    });

    const recompute = recomputeAllThrottled.bind(null, root);
    recompute();

    if('ResizeObserver' in window){
      const ro = new ResizeObserver(recompute);
      ro.observe(root);
    } else {
      window.addEventListener('resize', recompute);
    }
    const mq = window.matchMedia('(max-width: 749px)');
    if(mq.addEventListener){ mq.addEventListener('change', recompute); }
    else if(mq.addListener){ mq.addListener(recompute); }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(recompute).catch(function(){});
    }

    // Recompute when any product image finishes loading
    root.querySelectorAll('img').forEach(function(img){
      if(!img.complete){
        img.addEventListener('load', recompute, { once:true });
      }
    });

    // Observe late DOM injections (ratings widgets, prices, badges, etc.)
    const mo = new MutationObserver(throttleRaf(recompute));
    root.querySelectorAll('.ff-cc__track').forEach(function(track){
      mo.observe(track, { childList:true, subtree:true });
    });

    setTimeout(recompute, 120);
    setTimeout(recompute, 400);
    setTimeout(recompute, 1200);

    const initial = root.getAttribute('data-initial-tab');
    if(initial){
      selectTab(root, initial);
    } else if(tabs[0]){
      tabs[0].click();
    }
  }

  function initAll(){
    document.querySelectorAll('.ff-cc').forEach(initSection);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();